<script>
export default {
  name: "settingsProductIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.00065 14.6666H10.0007C13.334 14.6666 14.6673 13.3333 14.6673 9.99998V5.99998C14.6673 2.66665 13.334 1.33331 10.0007 1.33331H6.00065C2.66732 1.33331 1.33398 2.66665 1.33398 5.99998V9.99998C1.33398 13.3333 2.66732 14.6666 6.00065 14.6666Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.4668 6.17334L8.00012 8.22001L11.5068 6.18667"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 11.8466V8.21332"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.1735 4.19334L5.04016 5.38001C4.56016 5.64667 4.16016 6.32 4.16016 6.87334V9.13334C4.16016 9.68667 4.55349 10.36 5.04016 10.6267L7.1735 11.8133C7.62684 12.0667 8.3735 12.0667 8.8335 11.8133L10.9668 10.6267C11.4468 10.36 11.8468 9.68667 11.8468 9.13334V6.86667C11.8468 6.31334 11.4535 5.64 10.9668 5.37334L8.8335 4.18667C8.3735 3.93334 7.62684 3.93334 7.1735 4.19334Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
